import { logError } from '../utilities/AppInsightsUtil';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

function handleUserActions(statusFlags, userLogout, setStatusFlags, setGlobalBannerProps, getBanner, showUserBanner, setShowGlobalBanner, instance) {
    if (statusFlags.isAddedUser) {
        setGlobalBannerProps(getBanner('usernameAddedBanner', () => { setShowGlobalBanner(prevState => !prevState) }));
        showAndResetGlobalBanner(setShowGlobalBanner);
    }
    
    if (statusFlags.isMFAUpdated) {
        showUserBanner('We have successfully updated your phone number');
        showAndResetGlobalBanner(setShowGlobalBanner);
    }

    if (statusFlags.isUserUpdated) {
        showUserBanner('We have successfully updated your User ID (Email)');
        showAndResetGlobalBanner(setShowGlobalBanner);
    }

    if (statusFlags.isPWUpdated) {
        showUserBanner('We have successfully updated your password');
        showAndResetGlobalBanner(setShowGlobalBanner);
    }

    if(userLogout === 'true') {
        instance.logout();
    }

      const resetFlags = {};
      Object.keys(statusFlags).forEach(key => {
          if (statusFlags[key]) {
            resetFlags[key] = false;
          }
      });
      setStatusFlags(prevStatus => ({ ...prevStatus, ...resetFlags }));
}

function showAndResetGlobalBanner(setShowGlobalBanner) {
    setShowGlobalBanner(true);
    window.history.replaceState(null, '', window.location.pathname);
}

export { handleUserActions };
